import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';

import { GUIDED_TOURS_SHEET_HEADER } from './onboarding-slides.const';
import { GUIDED_TOURS, GuidedTourEntry } from './tours';

/**
 * The "Guided tours" chooser (Menu → Getting started). A modal with a close
 * button — the app's convention for a picker, not a bottom action sheet. Picks
 * an entry and dismisses; the caller (side menu) runs it once the modal is gone
 * so the tour spotlight isn't drawn under a closing sheet.
 */
@Component({
  selector: 'app-guided-tours-modal',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonTitle, IonToolbar],
  templateUrl: './guided-tours-modal.component.html',
})
export class GuidedToursModalComponent {
  private modalCtrl = inject(ModalController);

  protected readonly title = GUIDED_TOURS_SHEET_HEADER;
  protected readonly tours = GUIDED_TOURS;

  /** Dismiss with the chosen tour; the caller launches it after the modal closes. */
  protected pick(entry: GuidedTourEntry): void {
    void this.modalCtrl.dismiss(entry, 'selected');
  }

  protected close(): void {
    void this.modalCtrl.dismiss(null, 'cancel');
  }
}
